// AUTH mutations
import axios from 'axios';
import types from '../../types';

export default {
  [types.SHOW_APP_VIEWS]: (state, payload) => {
    state.showAppViews = payload;
  },
  [types.LOGOUT]: (state) => {
    state.token = '';
    state.info = null;
    state.userLogged = false;
    state.subaccounts = [];
    localStorage.removeItem('subaccount');
    localStorage.removeItem('userId');
    localStorage.removeItem('importQueue');
    delete axios.defaults.headers.common.Authorization;
  },
  [types.SET_BOOTSTRAP_COMPLETE]: (state) => {
    state.bootstrapComplete = true;
  },
  [types.LOGIN_USER_FLAG]: (state, payload) => {
    state.userLogged = payload;
  },
  [types.STORE_TOKEN]: (state, payload) => {
    state.token = payload;
  },
  [types.STORE_USER]: (state, payload) => {
    state.info = payload;
  },
  [types.STORE_SUBACCOUNTS]: (state, payload) => {
    state.subaccounts = payload;
  },
  [types.STORE_ACTIVE_SUBACCOUNT]: (state, payload) => {
    state.activeSubaccount = payload;
    localStorage.subaccount = JSON.stringify(payload);
  },
};
